




import { Component, Vue } from 'vue-property-decorator';
import Assets from '@/components/Assets.vue';

@Component({
  components: {
    Assets,
  },
})
export default class Resources extends Vue {}
